export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white mt-12">
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 md:grid-cols-4 gap-8">
        
        {/* About */}
        <div>
          <h3 className="text-lg font-semibold mb-3">About Us</h3>
          <p className="text-sm text-gray-300">
            Shree Engineering is a global provider of fabrication, SPM, ovens, 
            spray booths, transformers, and electrical supplies. 
            We deliver reliable engineering solutions trusted by industries worldwide.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Quick Links</h3>
          <ul className="space-y-2 text-sm text-gray-300">
            <li><a href="/" className="hover:underline">Home</a></li>
            <li><a href="/about" className="hover:underline">About</a></li>
            <li><a href="/products" className="hover:underline">Products</a></li>
            <li><a href="/contact" className="hover:underline">Contact</a></li>
            <li><a href="/privacy-policy" className="hover:underline">Privacy Policy</a></li>
            <li><a href="/terms" className="hover:underline">Terms & Conditions</a></li>
          </ul>
        </div>

        {/* Offices */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Our Offices</h3>
          <p className="text-sm text-gray-300">
            📍 Head office: C52 KSSIDC Industrial Area, Hoskote, Bengaluru, Karnataka - 562114
          </p>
          <br />
          <p className="text-sm text-gray-300">
            📍 Work office: #B-265, 6th main, 2nd stage, Peenya industrial area, Bangalore - 560058. Karnataka, India
          </p>
        </div>

        {/* Contact */}
        <div>
          <h3 className="text-lg font-semibold mb-3">Contact</h3>
          <p className="text-sm text-gray-300">✉️ Email: contact@shree-eng.com</p>
          <p className="text-sm text-gray-300">📞 India: +91 99725 29464</p>
          <p className="text-sm text-gray-300">📞 International: +966 54 764 6782</p>
          
        </div>
      </div>

      {/* Bottom */}
      <div className="bg-gray-800 py-4 text-center text-sm text-gray-400">
        © {new Date().getFullYear()} Shree Engineering. All rights reserved.  
        Design & Developed by{" "}
        <a
          href="https://www.prajnansoftwares.com/aboutus"
          target="_blank"
          rel="noopener noreferrer"
          className="text-orange-400 hover:underline"
        >
          Prajnan Software Pvt Ltd
        </a>
      </div>
    </footer>
  );
}
